module.exports = __webpack_public_path__ + "static/media/Rejected.32a36ce9.svg";